import { React, useState, useEffect, useRef } from "react";
import api from "../services/api";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import Title from "../Components/Utils";
import LinkSignUp from "../Components/LinkSignUp";
import ReCAPTCHA from "react-google-recaptcha";
import validator from "validator";
import { Link, useNavigate } from "react-router-dom"; 
import { Loader } from "../Components/Loader";
import { BASEURL } from "../CONSTANTS";
import { useScreenSize, useCustomScreen } from "../../src/Components/Utils";

export default function ForgotPassword() {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEMailValid] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();

  const { isIpadProPortrait } = useCustomScreen();

  const onChange = (value) => {
    console.log("Captcha value:", value);
  };
  const onEmailHandle = (e) => {
    const email = e.target.value;
    setEmail(e.target.value);
    if (validator.isEmail(email)) {
      setIsEMailValid(true);
    } else {
      setIsEMailValid(false);
    }
  };
  const sendMail = async () => {
    try {
      setLoading(!loading);
      const response = await fetch(`${BASEURL}auth/forgot-password/${email}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.text();

      if (response.ok) {
        setData(result);
        setShow(!show);
        setEmail("");
      } else {
        let parsedResult = JSON.parse(result);

        setData(
          parsedResult.message || "An error occurred while sending the email."
        );
      }
    } catch (e) {
      console.log(e);
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container
        className="gap-sm-3 account-login"
        style={{
          // marginBottom: "2em",
          marginTop: isSmallScreen ? "6rem" : "",
          height: "100%",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row
          style={{
            height: isSmallScreen ? "100vh" : "40vh",
            width: isSmallScreen
              ? "90%"
              : isIpadProPortrait
              ? "100%"
              : isMediumScreen
              ? "100%"
              : "70%",
          }}
        >
          {/* Left Side - Forgot Password Form */}
          <Col
            xl={8}
            lg={isIpadProPortrait ? 8 : 8}
            md={isMediumScreen ? 8 : isIpadProPortrait ? 6 : 4}
            sm={12}
            className="mb-3"
          >
            <Card
              className="sign-up"
              style={{
                boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Card.Body style={{ width: "100%" }}>
                <p
                  style={{
                    textAlign: "center",
                    marginBottom: "1em",
                    fontSize: is4kScreen
                      ? "3rem"
                      : isXxlScreen
                      ? "2.1rem"
                      : isXlScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2.1rem"
                      : isLargeScreen
                      ? "2rem"
                      : isMediumScreen
                      ? "1.6rem"
                      : "1.2rem",
                  }}
                  className="login-heading"
                >
                  {" "}
                  Forgot Password
                </p>
                {data ? (
                  <div
                    className="w-100 text-center"
                    style={{
                      flex: 1,
                      width: "100%",
                      height: "30vh",
                      minHeight: "100%",
                    }}
                  >
                    <p className="fs-7">{data}</p>
                  </div>
                ) : (
                  <Form className="p-4">
                    {/* Email Input - Responsive */}
                    <Form.Group className="mb-3">
                      <Row className="align-items-center">
                        {/* Label */}
                        <Col
                          md={3}
                          sm={12}
                          lg={2}
                          className="text-md-end   text-sm-start"
                        >
                          <Form.Label
                            className="fw-bold text-center"
                            style={{
                              fontSize: is4kScreen
                                ? "2rem"
                                : isXxlScreen
                                ? "1.25rem"
                                : isXlScreen
                                ? "1.05rem"
                                : isIpadProPortrait
                                ? "1.8rem"
                                : isLargeScreen
                                ? "1rem"
                                : isMediumScreen
                                ? "1.3rem"
                                : isSmallScreen
                                ? ""
                                : "1rem",
                            }}
                          >
                            Email
                          </Form.Label>
                        </Col>

                        {/* Input Field */}
                        <Col md={9} sm={12} lg={10}>
                          <Form.Control
                            style={{
                              width: is4kScreen
                                ? "90%"
                                : isXxlScreen
                                ? "100%"
                                : isXlScreen
                                ? "90%"
                                : isLargeScreen
                                ? "100%"
                                : "",
                            }}
                            type="email"
                            value={email}
                            onChange={onEmailHandle}
                            placeholder="Enter your email"
                          />
                        </Col>
                      </Row>
                    </Form.Group>

                    {/* Recaptcha */}
                    <div
                      className="w-100  text-center recaptcha-wrapper  d-flex justify-content-center align-items-center"
                      style={{
                        paddingLeft: isIpadProPortrait
                          ? ""
                          : isLargeScreen
                          ? "2rem"
                          : isMediumScreen
                          ? "3rem"
                          : "",
                        paddingRight: isIpadProPortrait ? "5rem" : "",
                      }}
                    >
                      <ReCAPTCHA
                        className="responsive-recaptcha"
                        sitekey={siteKey}
                        onChange={() => {}}
                      />
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        variant="primary"
                        disabled={!isEmailValid}
                        onClick={sendMail}
                        className="px-4 login-btns mb-4 btn "
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.25rem"
                            : isXlScreen
                            ? "1.05rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? "1rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : isSmallScreen
                            ? ""
                            : "1rem",
                        }}
                      >
                        <Loader response={loading} action={"Submit"} />
                      </Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* Right Side - SignUp Card */}
          <Col md={isMediumScreen ? 4 : isIpadProPortrait ? 4 : 4}>
            <Card
              style={{
                boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "96%",
              }}
            >
               <Card.Body className=" d-flex flex-column justify-content-center align-items-center">
                <Row>
                  <Col md={12} className="d-flex my-auto">
                    <div className="g-4">
                      <div
                        // className={`${page !== "login" ? "" : "d-none"} pb-2`}
                        className="d-flex justify-content-center"
                      >
                      
                      </div>
                     <div className="g-4 d-flex justify-content-center align-items-center">
                               
                               <div
                                 className="d-flex justify-content-center align-items-center"
                                 style={{
                                   display: "flex",
                                   flexDirection: "column",
                                   justifyContent: "center",
                                   alignItems: "center",
                                   textAlign: "center",
                                   padding: "0px 2em",
                                 }}
                               >
                                 <p
                                   className="login-heading"
                                   style={{
                                     fontSize: is4kScreen
                                       ? "3rem"
                                       : isXxlScreen
                                       ? "1.8rem"
                                       : isXlScreen
                                       ? "1.5rem"
                                       : isIpadProPortrait
                                       ? "2.1rem"
                                       : isLargeScreen
                                       ? "1.7rem"
                                       : isMediumScreen
                                       ? "1.6rem"
                                       : "1.2rem",
                                   }}
                                 >
                                   Don't have an account?
                                 </p>
                                 <br></br>
                                 <p
                                   style={{
                                     fontSize: is4kScreen
                                       ? "2rem"
                                       : isXxlScreen
                                       ? "1.25rem"
                                       : isXlScreen
                                       ? "1.05rem"
                                       : isIpadProPortrait
                                       ? "1.8rem"
                                       : isLargeScreen
                                       ? "1rem"
                                       : isMediumScreen
                                       ? "1.3rem"
                                       : isSmallScreen
                                       ? ""
                                       : "1rem",
                                   }}
                                 >
                                   {" "}
                                   It's easy and free to sign up!
                                 </p>
                                 <br></br>
                                 <Button
                                   variant="primary"
                                   type="submit"
                                   className="login-btns btn mb-3"
                                   onClick={() => navigate("/signup")}
                                   style={{
                                     fontSize: is4kScreen
                                       ? "2rem"
                                       : isXxlScreen
                                       ? "1.25rem"
                                       : isXlScreen
                                       ? "1.05rem"
                                       : isIpadProPortrait
                                       ? "1.8rem"
                                       : isLargeScreen
                                       ? "1rem"
                                       : isMediumScreen
                                       ? "1.3rem"
                                       : isSmallScreen
                                       ? ""
                                       : "1rem",
                                   }}
                                 >
                                   Sign Up
                                 </Button>
                               </div>
                             </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
